import { Col, Row } from "@visa/vds"
import { DateHelper } from "_helpers/DateHelper"
import React from "react"
import CertificationPackageState from "../SharedComponents/CertificationPackageState"
import VstsAccessStatus from "../SharedComponents/VstsAccessStatus"

const CertificationPackageBanner = ({ banner, isAdmin }) => {
    let bannerInformation = [
        {
            header: "ID:",
            value: banner.id
        },
        {
            header: "Business Name:",
            value: banner.businessName
        },
        {
            header: "BID:",
            value: banner.bid
        },
        {
            header: "Country:",
            value: banner.country
        },
        {
            header: "Region:",
            value: banner.region
        },
    ]

    if (isAdmin) bannerInformation.push({ header: "Last Updated By:", value: banner.lastUpdatedBy })
    bannerInformation = bannerInformation.concat([
        {
            header: "Last Updated On:",
            value: DateHelper.ToFormattedDate(banner.lastUpdatedOn)
        },
        {
            header: "Created By:",
            value: banner.createdBy
        },
        {
            header: "Created On:",
            value: DateHelper.ToFormattedDate(banner.createdOn)
        },
    ])

    return (
        <>
            <Row>
                <Col>
                    <Row>
                        <CertificationPackageState packageState={banner.certificationPackageState} />
                        {bannerInformation && bannerInformation.map((item, idx) =>
                            <Col
                                key={idx}
                                className="
                            certification-package-banner-column 
                            certification-package-banner-left-line 
                            " >
                                <div>
                                    <span className="certification-package-banner-item-header">{item.header}</span>
                                    <span className="certification-package-banner-item-value">{item.value}</span>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <VstsAccessStatus
                            vstsAccessDescriptionNo={banner.vstsAccessStatus.vstsAccessDescription}
                            className="dashboard-web-view vsts-status"
                            vstsAccess={banner.vstsAccessStatus.vstsAccess}
                            vstsAccessDescription={banner.vstsAccessStatus.vstsAccessDescriptionText} />
                    </Row>
                </Col>
            </Row >
        </>

    )
}

export default CertificationPackageBanner